import { Draft } from 'immer';
import { v4 as uuid } from 'uuid';

import { Common, Store } from 'app/interfaces';

import { FetchProvidersResponse, ProviderDetailResponse } from 'app/interfaces/api';
import setAvailableProviders from './setAvailableProviders';
import setIdToken from './setIdToken';
import setProviderDetails from './setProviderDetails';
import setTransactionID from './setTransactionID';
import updateAvailability from './updateAvailability';
import updateTransaction from './updateTransaction';

const actions: (state: Draft<Store.State>) => Store.Actions = state => {
  return {
    reset() {
      return state;
    },

    updateAvailability(availability: Common.Availability) {
      updateAvailability(state, availability);
    },

    startTransaction(transactionType: Common.TransactionType) {
      const transaction: Common.Transaction = {
        ID: uuid(),
        startTs: +new Date()
      };
      updateTransaction(state, transaction, transactionType);
    },

    setIdToken(idToken: string) {
      setIdToken(state, idToken);
    },

    setProviderDetails(providerDetails: ProviderDetailResponse) {
      setProviderDetails(state, providerDetails);
    },

    setAvailableProviders(providers: FetchProvidersResponse) {
      setAvailableProviders(state, providers);
    },

    setTransactionID(newId: string, transactionType: Common.TransactionType) {
      setTransactionID(state, newId, transactionType);
    }
  };
};

export default actions;
